import {useEffect, useRef} from 'react';

import {Canvas, FabricText} from 'fabric';

// Patch Fabric.js Text class ONCE at module load time
// This prevents crashes when Fabric.js internally creates Text objects with undefined text
const originalSplitText = FabricText.prototype._splitTextIntoLines;

FabricText.prototype._splitTextIntoLines = function(text) {
    // Ensure text is always defined before splitting
    const safeText = (text === undefined || text === null) ? '' : text;
    return originalSplitText.call(this, safeText);
};

const useFabric = (onInit, options) => {
    const canvasRef = useRef(null);
    const canvasInstanceRef = useRef(null);
    const initializedRef = useRef(false);

    useEffect(() => {
        if (!canvasRef.current || initializedRef.current) {
            return;
        }

        const canvas = new Canvas(canvasRef.current, options);
        canvasInstanceRef.current = canvas;
        initializedRef.current = true;

        onInit && onInit(canvas);

        return () => {
            if (canvasInstanceRef.current) {
                canvasInstanceRef.current.dispose();
                canvasInstanceRef.current = null;
                initializedRef.current = false;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Only run once on mount

    return canvasRef;
};

export default useFabric;